// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "LatestInsightsModule-module--arrow-up-and-down--1fa32";
export var card = "LatestInsightsModule-module--card--7b011";
export var cardsContainer = "LatestInsightsModule-module--cardsContainer--6edb6";
export var container = "LatestInsightsModule-module--container--c6f0a";
export var contentContainer = "LatestInsightsModule-module--contentContainer--524eb";
export var greenBackground = "LatestInsightsModule-module--greenBackground--f0d80";
export var link = "LatestInsightsModule-module--link--2328e";
export var purpleBackground = "LatestInsightsModule-module--purpleBackground--333bd";
export var whiteBackground = "LatestInsightsModule-module--whiteBackground--bb90d";